import classNames from 'classnames/bind';
import styles from './option.module.scss';

const cx = classNames.bind(styles);

export enum SortStyle {
  ASCENDING = 'ascending',
  DESCENDING = 'descending',
  ORDER = 'order',
}

const classes = {
  [SortStyle.ASCENDING]: styles.ascending,
  [SortStyle.DESCENDING]: styles.descending,
  [SortStyle.ORDER]: styles.order,
};

interface IProps {
  activate: boolean;
  clickCode?: string;
  sortStyle?: SortStyle;
  subtitle?: string;
  title: string;
  selectFunc: () => void;
}

function Option({
  activate,
  clickCode = '',
  sortStyle,
  subtitle,
  title,
  selectFunc,
}: IProps) {
  return (
    <button
      type="button"
      className={cx('option')}
      aria-selected={activate}
      data-event-nlog="click"
      data-event-area-code={clickCode}
      onClick={selectFunc}
    >
      <span className={cx('txt')}>{title}</span>
      {subtitle && (
        <i className={sortStyle && classes[sortStyle]}>{subtitle}</i>
      )}
    </button>
  );
}

export default Option;
